import { FC, useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import {
  VsTransferEvent,
  useGetHeroConversationById,
} from '@vs-online-only-app/state';

type Props = {
  transferRequest: VsTransferEvent;
};

export const CancelledTransferBanner: FC<Props> = ({ transferRequest }) => {
  const { data: conversation } = useGetHeroConversationById(
    transferRequest.conversation
  );
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);

  if (!isVisible || !conversation) {
    return null;
  }

  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Alert severity="info">
        Your transfer for {conversation?.conversationStarter.firstName} was
        successfully canceled.
      </Alert>
    </Snackbar>
  );
};
